import { combineReducers } from 'redux';

import * as types from 'modules/leads/actionTypes';

import { createLeadModalReducer } from './createLeadModalReducer';

export default combineReducers({
  assign: createLeadModalReducer(types.OPEN_ASSIGN_MODAL, types.CLOSE_ASSIGN_MODAL, types.ASSIGN_SUCCESS),
  directMessage: createLeadModalReducer(types.OPEN_CREATE_DM_MODAL, types.CLOSE_CREATE_DM_MODAL, types.CREATE_DM_SUCCESS),
});
